export default __webpack_public_path__ + "static/media/ic_cycle_block.3e434640.svg";